import React from 'react';
import Stage from '@boschebike/ebds-react/dist-esm/components/Stage.js';
import ComponentButton from './componentButton.js';
import ComponentLoginButton from './componentLoginButton.js';
/**
 * @typedef {import('../../App.d.ts').StageProps} StageProps
 */

/**
 * @param {StageProps} props
 */
const getVideoSources = (props) => {
  if (!props.videoUrlType) {
    return undefined;
  }

  const videoSources = [
    <source
      src={props.videoUrlPortrait}
      type="video/webm"
      media="(orientation: portrait)"
      key={props.videoUrlPortrait}
    />,
    <source
      src={props.videoUrlLandscape}
      type="video/webm"
      media="(orientation: landscape)"
      key={props.videoUrlLandscape}
    />,
  ];

  return videoSources;
};

/**
 * @typedef {import('../../App.d.ts').Stage} Stage
 */
/**
 * @param {StageProps} props
 */
const getPrimaryButton = (props) => {
  if (!props.button) {
    return null;
  }

  // @ts-ignore
  const type = props?.button?.type ?? props?.button?.sys?.contentType?.sys?.id;
  if (type === 'componentLoginButton') {
    // @ts-ignore
    return <ComponentLoginButton {...props.button.fields} />;
  }
  // @ts-ignore
  return <ComponentButton {...props.button.fields} />;
};

/**
 * @param {StageProps} props
 */
export default (props) => {
  // Quick fix. When using createContentfulElement it would spawn <div>, but Stage renders stuff
  // in a <p> element. Stage should only accept strings as a description then.
  // @refactor
  const description = props.descriptionRaw;
  return (
    <Stage
      data-testid="stage"
      version={props.version}
      orientation={props.orientation}
      headline={props.headline}
      description={description}
      button={getPrimaryButton(props)}
      secondaryButton={props.secondaryButton ? <ComponentButton {...props.secondaryButton.fields} /> : null}
      img={props.image ? (
        <img
          className="stage-image"
          src={props.image.fields.file.url}
          srcSet={props.image.fields.file.srcSet?.join(',')}
          alt={props.image.fields.file.imgAlt || ''}
        />
      ) : undefined}
      withCoverImage={props.withCoverImage}
      videoSources={getVideoSources(props)}
      videoPoster={props.videoPoster}
    />
  );
};
